<script setup lang="ts">
import TheHeader from '@/components/organisms/TheHeader/TheHeader.vue'
import TheHeaderV2 from '@/components/organisms/TheHeader/TheHeaderV2.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useV2 as useV2Composable } from '@/composables/useV2'

const route = useRoute()

const useTransparentTheme = computed(() => route.meta.useTransparentLayout as boolean)

/* Use shared composable for V2 detection to keep behavior consistent across pages */
const useV2 = useV2Composable()
</script>
<template>
    <TheHeaderV2
        v-if="useV2"
        :useWhiteLogo="useTransparentTheme"
        :class="useTransparentTheme ? 'header--transparent' : ''"
    />
    <TheHeader
        v-else
        :useWhiteLogo="useTransparentTheme"
        :class="useTransparentTheme ? 'header--transparent' : ''"
    />
    <ErrorMessage />
    <main
        class="container-fluid main"
        :class="useTransparentTheme ? 'main--transparent' : ''"
    >
        <slot></slot>
    </main>
</template>

<style lang="scss" scoped>
.main {
   // background: $white;

    &--transparent {
        background-color: transparent;
        position: relative;
    }
}


</style>
